var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sidebar-buttons"}},[(!_vm.isCompact)?_c('b-button',{attrs:{"variant":"outline-light"},on:{"click":function($event){$event.preventDefault();return _vm.resizeNavbar()}}},[_c('font-awesome-icon',{attrs:{"icon":"angle-double-left","size":"lg"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }